import PropTypes from "prop-types";

const QuestionCard = ({
  questionNumber,
  totalQuestions,
  question,
  selectedAnswer,
  onAnswerSelect,
}) => {
  if (!question) {
    return null;
  }

  const options = question.options || [];

  return (
    <div className="bg-white rounded-lg shadow-sm border p-5">
      {/* Question Header */}

      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-800">
          Question {questionNumber} of {totalQuestions}
        </h3>

        <span className="text-sm font-medium text-gray-500">
          {question.marks ?? 0} Marks
        </span>
      </div>

      {/* Question Text */}

      <div className="mb-5">
        <p className="text-gray-700 text-base leading-relaxed">
          {question.questionText}
        </p>
      </div>

      {/* Options */}

      <div className="space-y-3">
        {options.map((option, index) => {
          const optionLabel = option.key || String.fromCharCode(65 + index);

          const optionText = option.text || option;

          const isSelected = selectedAnswer === optionLabel;

          return (
            <button
              key={option._id || optionLabel}
              type="button"
              aria-pressed={isSelected}
              onClick={() =>
                onAnswerSelect(question._id, optionLabel)
              }
              className={`
                w-full
                text-left
                border
                rounded-lg
                p-3
                transition
                flex
                items-center
                gap-3

                ${
                  isSelected
                    ? "border-blue-600 bg-blue-50 text-blue-700"
                    : "border-gray-300 hover:border-blue-400"
                }
              `}
            >
              {/* Option Label */}

              <span
                className={`
                  flex
                  items-center
                  justify-center
                  w-8
                  h-8
                  rounded-full
                  text-sm
                  font-semibold

                  ${
                    isSelected
                      ? "bg-blue-600 text-white"
                      : "bg-gray-100 text-gray-700"
                  }
                `}
              >
                {optionLabel}
              </span>

              {/* Option Text */}

              <span>{optionText}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

QuestionCard.propTypes = {
  questionNumber: PropTypes.number.isRequired,

  totalQuestions: PropTypes.number.isRequired,

  question: PropTypes.shape({
    _id: PropTypes.string.isRequired,

    questionText: PropTypes.string.isRequired,

    options: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string,
        key: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      }),
    ),

    marks: PropTypes.number,
  }).isRequired,

  selectedAnswer: PropTypes.string,

  onAnswerSelect: PropTypes.func.isRequired,
};

QuestionCard.defaultProps = {
  selectedAnswer: null,
};

export default QuestionCard;